import React from 'react';
import sortBy from 'lodash/sortBy';
import { Flex, Box, Heading, Text, Modal, ModalHeader, ModalBody, Image, } from '@spothero/ui';
import PackageInfo from '../package-info';
import EventInfo from '../event-info';
const DetailsModal = ({ modalVisible, onHidden, activePackage, }) => {
    const { title, description, events } = activePackage?.eventPackage || {};
    const { timezone } = activePackage?.destination || {};
    const eventCount = events?.length;
    // sort events to make sure they are in chronological order
    const sortedEvents = sortBy(events, [
        event => event.starts.replace(/\D/g, ''),
    ]);
    return (<Modal onClose={onHidden} className="DetailsModal" data-testid="DetailsModal" title="Package Details" isOpen={modalVisible} hasHeader hasFooter={false}>
            <ModalHeader textAlign="center">Package Details</ModalHeader>
            <ModalBody>
                {title ? (<Flex direction="column">
                        <PackageInfo title={title} description={description} eventCount={eventCount}/>
                        <Box>
                            {eventCount ? (<Box marginY={4} paddingTop={4} borderTopWidth="1px" borderColor="gray.200">
                                    <Heading as="h3" variant="h5" marginBottom={4}>
                                        Parking Included
                                    </Heading>
                                    <Flex backgroundColor="gray.50" borderRadius="0.5rem" padding={3} marginBottom={4}>
                                        <Box width={8} height={8} marginRight={3}>
                                            <Image src="/img/event-packages/icon-time-buffer.svg" alt="Timer Icon"/>
                                        </Box>
                                        <Text flex="1" fontSize="xs">
                                            No rush! Every parking reservation
                                            starts at least{' '}
                                            <strong>1hr before</strong> the
                                            event starts, and ends{' '}
                                            <strong>1hr after</strong> the event
                                            ends, even if it runs late.
                                        </Text>
                                    </Flex>
                                    {sortedEvents.map((event, index) => (<EventInfo event={event} key={index} timezone={timezone}/>))}
                                </Box>) : (<Heading as="h3" textAlign="center" pt={8}>
                                    There are no events available for this
                                    package
                                </Heading>)}
                        </Box>
                    </Flex>) : (<Heading as="h3" textAlign="center">
                        Sorry, something went wrong loading the events
                    </Heading>)}
            </ModalBody>
        </Modal>);
};
export default DetailsModal;
